package br.com.vvrefeicoes.portal.feature.monitor

import org.w3c.dom.WebSocket

actual class PublicMonitorSocket actual constructor(
    companyId: String,
    private val onUpdate: () -> Unit,
) {
    private val socket = WebSocket("wss://pesquisa.api.vvrefeicoes.com.br/socket.io/?EIO=4&transport=websocket")

    init {
        socket.onopen = {
            socket.send("40")
            socket.send("42[\"joinCompanyRoom\",\"$companyId\"]")
            null
        }
        socket.onmessage = { event ->
            val message = event.data as? String
            if (message != null) {
                when {
                    message == "2" -> socket.send("3")
                    message.contains("voteUpdate") || message.contains("companyUpdate") -> onUpdate()
                }
            }
            null
        }
    }

    actual fun close() {
        socket.close()
    }
}
